import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:80/api'

const API_ROOT_VER = '/v1/audit'

export const getProjectInternalAudit = () => {
  // /api/v1/audit/project-internal-audit/page
  const url = `${API_ROOT}/v1/audit/project-internal-audit/page`
  // const url = 'http://localhost/api/v1/audit/project-internal-audit/page'
  return doGet(url)
}

export const searchProjectInternalAudit = (request) => {
  const url = `${API_ROOT}/v1/audit/project-internal-audit/preview`
  // const url = 'http://localhost/api/v1/audit/project-internal-audit/preview'
  return doPost(url, request)
}

export const exportProjectInternalAudit = (request) => {
  // /api/files/download/project-internal-audit
  const url = `${API_ROOT}/files/download/project-internal-audit`
  // const url = `http://localhost:80/api/files/download/project-internal-audit`
  return doPostDownload(url, request)
}
